var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var FieldHandler = /** @class */ (function () {
    function FieldHandler(_a) {
        var _this = this;
        var value = _a.value, defaultValue = _a.defaultValue, label = _a.label, required = _a.required, mask = _a.mask, maskToSubmit = _a.maskToSubmit, validation = _a.validation, asyncValidation = _a.asyncValidation, errorHandler = _a.errorHandler, validHandler = _a.validHandler, handleValue = _a.handleValue, setLoading = _a.setLoading, disableHandler = _a.disableHandler, ref = _a.ref;
        this.error = false;
        this.getError = function () {
            return _this.error;
        };
        this.setRequired = function (required) {
            _this.required = required;
        };
        this.setDefaultValue = function (defaultValue) {
            _this.defaultValue = defaultValue;
        };
        this.setLabel = function (label) {
            _this.label = label;
        };
        this.setMask = function (mask) {
            _this.mask = mask;
        };
        this.setMaskToSubmit = function (maskToSubmit) {
            _this.maskToSubmit = maskToSubmit;
        };
        this.setValidation = function (validation) {
            _this.validation = validation;
        };
        this.setAsyncValidation = function (asyncValidation) {
            _this.asyncValidation = asyncValidation;
        };
        this.setValue = function (newValue) {
            _this.value = newValue;
        };
        this.getRef = function () {
            return _this.ref;
        };
        this._clearValue = function () {
            _this.handleValue("");
        };
        this._setValueToDefault = function () {
            _this.handleValue(_this.defaultValue);
        };
        this.clearValue = function (setDefault) {
            if (setDefault) {
                _this._setValueToDefault();
            }
            else {
                _this._clearValue();
            }
        };
        this.getFormattedValueToSubmit = function (ffHandler) {
            var fixedValue = _this.value;
            if (typeof _this.value === "string") {
                fixedValue = _this.value.trim();
            }
            else if (typeof _this.value === "number") {
                fixedValue = Number(String(_this.value).trim());
            }
            return !!_this.maskToSubmit && fixedValue
                ? _this.maskToSubmit(fixedValue, ffHandler)
                : fixedValue;
        };
        this.validate = function (shouldUpdateInput, ffHandler) { return __awaiter(_this, void 0, void 0, function () {
            var maskedValue, hasValue, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maskedValue = this._getMaskedValue();
                        hasValue = Boolean(maskedValue) || maskedValue === 0;
                        if (!hasValue) return [3 /*break*/, 2];
                        if (!(this.validation || this.asyncValidation)) return [3 /*break*/, 2];
                        this.setLoading(true);
                        return [4 /*yield*/, this._getErrorMessage(maskedValue, ffHandler)];
                    case 1:
                        errorMessage = _a.sent();
                        this.setLoading(false);
                        if (errorMessage) {
                            if (shouldUpdateInput) {
                                this.errorHandler(errorMessage);
                                this.validHandler(false);
                            }
                            this.error = true;
                            return [2 /*return*/, errorMessage];
                        }
                        else {
                            if (shouldUpdateInput) {
                                this.errorHandler("");
                                this.validHandler(true);
                            }
                            this.error = false;
                            return [2 /*return*/, null];
                        }
                        _a.label = 2;
                    case 2:
                        if (Boolean(this.required)) {
                            if (shouldUpdateInput) {
                                this.errorHandler(hasValue ? "" : this.required);
                                this.validHandler(hasValue);
                            }
                            this.error = !hasValue;
                            return [2 /*return*/, hasValue ? null : this.required];
                        }
                        if (shouldUpdateInput) {
                            this.validHandler(true);
                            this.errorHandler("");
                        }
                        this.error = false;
                        return [2 /*return*/, null];
                }
            });
        }); };
        this.value = value;
        this.defaultValue = defaultValue;
        this.label = label;
        this.required = required;
        this.mask = mask;
        this.maskToSubmit = maskToSubmit;
        this.validation = validation;
        this.asyncValidation = asyncValidation;
        this.errorHandler = errorHandler;
        this.validHandler = validHandler;
        this.handleValue = handleValue;
        this.setLoading = setLoading;
        this.disableHandler = disableHandler;
        this.ref = ref;
    }
    FieldHandler.prototype._getMaskedValue = function () {
        return this.mask ? this.mask(this.value) : this.value;
    };
    FieldHandler.prototype._getErrorMessage = function (value, ffHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var message, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.validation) {
                            message = this.validation(value, ffHandler);
                            if (message)
                                return [2 /*return*/, message];
                        }
                        if (!this.asyncValidation) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.asyncValidation(value, ffHandler)];
                    case 1:
                        message = _a.sent();
                        if (message)
                            return [2 /*return*/, message];
                        _a.label = 2;
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    return FieldHandler;
}());
export { FieldHandler };
